import script from "./OptionBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./OptionBox.vue?vue&type=script&lang=ts&setup=true"

import "./OptionBox.vue?vue&type=style&index=0&id=1a1e018b&lang=postcss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a1e018b"]])

export default __exports__